import { ROLES } from "./constants/roles";
import { STATUS } from "./constants/status";

export const checkPermission = (
  userRole,
  billStatus,
  isCreator,
  action,
  departmentApprove,
  directorApprove,
) => {
  const permissions = {
    [STATUS.CREATED]: {
      user: {
        view: (creator) => creator,
        update: (creator) => creator,
        reject: () => false,
        request: (creator) => creator,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.ACCOUNTS]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
    },
    [STATUS.REQUESTED]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => true,
        reject: () => true,
        request: () => false,
        approve: () => true,
        disburse: () => false,
        editApprovedAmount: () => true,
      },
      [ROLES.DIRECTOR]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.ACCOUNTS]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
    },
    [STATUS.APPROVED_BY_DEPT_HEAD]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => false,
        reject: () => true,
        request: () => false,
        approve: () => true,
        disburse: () => false,
        editApprovedAmount: () => true,
      },
      [ROLES.ACCOUNTS]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
    },
    [STATUS.APPROVED_BY_DIRECTOR]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.ACCOUNTS]: {
        view: () => true,
        update: () => false,
        reject: () => true,
        request: () => false,
        approve: () => true,
        disburse: () => false,
        editApprovedAmount: () => true,
      },
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
    },
    [STATUS.APPROVED_BY_F_N_A]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.ACCOUNTS]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => true,
      },
    },
    [STATUS.REJECTED]: {
      user: {
        view: (creator) => creator,
        update: (creator) => creator,
        reject: () => false,
        request: (creator) => creator,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.ACCOUNTS]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
    },
    [STATUS.DISBURSED]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.ACCOUNTS]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        disburse: () => false,
      },
    },
  };

  const roleKey = Object.values(ROLES).includes(userRole) ? userRole : "user";
  const statusPermissions = permissions[billStatus] || {};
  const rolePermissions = statusPermissions[roleKey] || statusPermissions.user || {};

  const rule = rolePermissions[action];
  if (typeof rule === "function") {
    return rule(isCreator);
  }

  return false;
};
